const ConsumerFilterOrder = {
    customOrder: [
        "Gender",
        "Age Range",
        "Consumer Exact Age",
        "Ethnicity",
        "Country Region",
        "Activity Level (Day)",
        "Activity Level (Week)",
        "Showers a Day (Freq.)",
        "AP or Deo User",
        "Format of Antiperspirant & Deodorant",
        "Format of Antiperspirant & Deodorant being tested",
        "Dual User",
        "Non-Rejector of Format",
        "Deo/AP Current Usage Frequency",
        "Consumer's Current Brand",
        "Product Purchased From",
        "Sweater Type",
        "Sweat Moments",
        "Most Important Sweat Moment",
        "Applied to Body Area",
        "Applied Product more than once (Why?)",
        "At what times of day did you apply the product?",
        "Topups Product",
        "Top-up products used during trial period",
        "1st Most Sought Benefit",
        "2nd Most Sought Benefit",
        "3rd Most Sought Benefit",
        "4th Most Sought Benefit",
        "5th Most Sought Benefit",
        "6th Most Sought Benefit",
        "7th Most Sought Benefit",
        "User Recogniser of the Blind Product",
        "Brand correctly recognised",
        "Brand recognised correctly of the Blind Product",
        "Test Code",
        "Test Design",
        "City",
        "Skin Irritations",
        "Hair removal during test",
    ],
    customOrderOralCare: [
        "Sample Type",
        "City",
        "Age Range",
        "LSM bracket",
        "Usership",
        "Brand Usership",
        "Gender",
        "Format of OC being tested",
        "Tube opening Experience",
        "Packaging Information",
        "How much Paste",
        "Usual Brushing Time Toothpaste",
        "Brushing Frequency",
        "Brushing Time",
        "Usual Brushing Time",
        "Usual Brushing Time Toothpowder",
        "Toothbrush Type",
        "Frequency of Use of Toothpowder",
        "How Toothpowder is applied on Brush",
        "Toothpowder Single brushing Occasion",
        "Water Usage while Brushing",
        "How many Times Rinsed Mouth After Brushing",
        "Oral Care Product Other Than Toothpowder",
        "When Last Used Product",
        "Do Family Members Use Oral Care Products",
        "Toothpowder lasting period",
        "Frequency of Use in the between 7 to 14 Days",
        "Other Product Used to Clean Teeth",
    ],
    customOrderSkinCleansing: [
        "Blind Branded",
        "City",
        "Gender",
        "Exact LSM",
        "Age Range",
        "Brand Usership",
        "Usership (Loyalty)",
        "Frequency of Usage",
        "Number of times body wash used",
        "Often usage-freq of usage",
        "Personal Usage of product (times prod used)",
        "Product Usage",
        "Implement used",
        "Time of Bathing Time",
        "Sample Type",
        "Test Code",
        "Test Design",
        "Test ID",
    ],
    customOrderUnileverFragranceHouseHUT: [
        "Age Range",
        "Gender",
        "City",
        "Consumer Exact Age",
        "Additional products used in wash",
        "Agree to info provided and book",
        "Allergy reaction in recent twelve months",
        "Applicable conditions",
        "Availablity consent",
        "Choice between product tested and most often used",
        "Company working details",
        "Current living situation be able to wear clothes after two days wash",
        "Cycle best describes just completed a wash on",
        "Describe decision to purchase laundry products",
        "Emotions felt after smelling frag",
        "Ethnicity",
        "Fabric conditioner used alongside",
        "Feel positive smelling product",
        "Feel smelling product",
        "Format of laundry detergent",
        "Frag feel unqiue different",
        "Frag fits Addictive",
        "Frag fits Chemical",
        "Frag fits Classic",
        "Frag fits Comforting / Relaxing",
        "Frag fits Energising",
        "Frag fits Exotic",
        "Frag fits Feminine",
        "Frag fits Fresh",
        "Frag fits Luxurious",
        "Frag fits Makes me feel good",
        "Frag fits Masculine",
        "Frag fits Natural / Outdoorsy",
        "Frag fits New and Different",
        "Frag fits Overpowering",
        "Frag fits Premium",
        "Frag fits Sophisticated",
        "Frag fits word onscreen",
        "Frag fits Worth paying more for",
        "Frag fits Youthful",
        "Frag in room with water used from laundry",
        "Frag of product assosciate with",
        "Frag strength fill room when clothes were drying",
        "Garment material",
        "Garment type",
        "Happy to replace current laundry detergent with different liquid detergent",
        "Like dislike doing laundry",
        "Likely would buy laundry detergent product if available",
        "Liquid laundry detergent brands currently use",
        "Liquid laundry detergent brands never use",
        "Market research study about",
        "Method used to dry clothes",
        "Miss most about the product tested",
        "Most fiting for frag",
        "Own a smartphone",
        "Product made feel unexpectedly lifted",
        "Products used alongside test product in washing",
        "Ranking",
        "Reuse water from laundry to clean",
        "Tempearture just completed wash on",
        "Types of products used at home",
        "Washes completed using test product in past seven days",
        "Weekly Avg of laundry done",
        "Working for company involved in marketing",
        "Would you be able to download app on phone",
    ],
    customOrderUnileverFragranceHouseCLT: [
        "Age Range",
        "Gender",
        "City",
        "Agree to information and wish to book",
        "Any conditions",
        "Availability and willing to take test at facility",
        "Brand of sachet shampoo used most often over past six months",
        "Brands would never use",
        "Color Vision",
        "Colour seen",
        "Consumer Exact Age",
        "Describe emotions bored",
        "Describe emotions comforted",
        "Describe emotions elegant",
        "Describe emotions energised",
        "Describe emotions enthusiastic",
        "Describe emotions feminine",
        "Describe emotions happy",
        "Describe emotions intrigued",
        "Describe emotions masculine",
        "Describe emotions nostalgic",
        "Describe emotions relaxed",
        "Describe emotions satisfied",
        "Describe yourself while purchasing household care products",
        "Disability",
        "Early adoptership",
        "Ethnicity",
        "Fabric conditioner brands used in past six months",
        "Format of shampoo you regularly use",
        "Frag preference",
        "Happy to take home usage survey",
        "Highest level of education",
        "Immediate family close friends currently work for any of following companies",
        "Items in working condition at home",
        "Last time participated in survey",
        "Laundry detergents used in past six months",
        "Laundry products used in past six month",
        "Loads of laundry using product within week fabric conditioner",
        "Market survey topic",
        "Member of household work for a company that manufactures or involved in marketing or advertising product types",
        "Number of rooms at home",
        "Often smoke tobacco products",
        "Order",
        "Own sporting or leisure items",
        "Person responsible for buying personal care products",
        "Post Fragrance like",
        "Pre Fragrance like",
        "Pregnancy",
        "Product attributes important for choosing shampoo",
        "Product purchase decision in last three months",
        "Products currently use",
        "Products used in six months",
        "Region",
        "Regularly wear hijab",
        "Research was about",
        "Shampoo brand best fits into",
        "Shampoo brands use regularly",
        "Shampoo brands used in past six months",
        "Shampoo frag usually use",
        "State",
        "Statements best describes attitude towards products specifically designed for sensitive skin gentle on skin",
        "Statements best describes relationship with fragranced products",
        "Suffered from an allergic reaction skin irritation past twelve months",
        "Survey participation in last six months",
        "Top three key factors to purchase shampoo",
        "Type of frag used for Bathroom cleaning",
        "Type of frag used for conditioner",
        "Type of frag used for deo",
        "Type of frag used for deo and anti perspirant",
        "Type of frag used for detergent",
        "Type of frag used for detergent",
        "Type of frag used for Fabric conditioner",
        "Type of frag used for Fabric Detergent Cleaner",
        "Type of frag used for hair shampoo",
        "Type of frag used for hair shampoo or conditioner",
        "Type of frag used for hair styling",
        "Type of frag used for Hairstyling products",
        "Type of frag used for kitchen",
        "Type of frag used for skin care",
        "Type of frag used for skin clean",
        "Type of frag used in skin cleansing of body or face",
        "Type of frag used in toilet cleaning",
        "Types of products currently used",
        "Usage for Bathroom cleaning",
        "Usage for conditioner",
        "Usage for deo",
        "Usage for deo and anti perspirant",
        "Usage for detergent",
        "Usage for detergent",
        "Usage for Fabric conditioner",
        "Usage for Fabric Detergent Cleaner",
        "Usage for hair shampoo",
        "Usage for hair shampoo or conditioner",
        "Usage for hair styling",
        "Usage for Hairstyling products",
        "Usage for kitchen",
        "Usage for skin care",
        "Usage for skin clean",
        "Usage in skin cleansing of body or face",
        "Usage in toilet cleaning",
        "Utilities used at home",
        "Weekly usage of shampoo on an average",
        "Willing to select pure sensitive fabric conditioner",
        "Willing to take part in research study",
        "Working order in your home",
        "Working order in your home TVs LCD / Plasma TVs",
        "Working order in your home Bicycle",
        "Working order in your home Black & white TVs",
        "Working order in your home Gaming consoles (home or portable / handheld)",
        "Working order in your home Glider / hang-glider / para-glider (no engine)",
        "Working order in your home Hot tub / Jacuzzi/Sauna",
        "Working order in your home Laptop computers",
        "Working order in your home Mobile phones / car phones",
        "Working order in your home Mobile phones with email facility",
        "Working order in your home Motor boat / sailing boat",
        "Working order in your home MP3 player / iPod",
        "Working order in your home Order_Motor cars",
        "Working order in your home PC / desktop computers",
        "Working order in your home Personal CD / cassette players",
        "Working order in your home Professional quality musical instrument (e.g. piano, violin etc.)",
        "Working order in your home Radio clocks",
        "Working order in your home Scuba diving/surfing equipment",
        "Working order in your home Skiing / snowboarding / ice skating equipment",
        "Working order in your home Stand-alone radios (excluding those built into hi-fi systems or clock-radios)",
        "Working order in your home Still cameras (digital)",
        "Working order in your home Still cameras (non-digital)",
        "Working order in your home Swimming pool",
        "Working order in your home Treadmill / other gym machines",
        "Working order in your home Video cameras (digital)",
        "Working order in your home Video cameras (non-digital)",
    ],
    customMacroCategoryOrderHairCare: ["Consumer Demographics", "Study Information", "Brand recognition", "Hair Characteristics", "Hair Routine", "Hair Needs and Concerns", "Benefits Most Often Used", "Pack", "Brand Usership"],
    customOrderSkinCare: ["Gender", "Consumer Exact Age", "Age Range", "Race", "Exact LSM", "LSM bracket", "Region", "Skin tone", "Skin type", "Sensitivity face skin", "Often wear hijab"],
    ConsumerDemographicsHairCare: ["Gender", "Age Range", "Consumer Exact Age", "Exact LSM", "LSM bracket", "Region"],
    StudyInformationHairCare: ["Recall number", "Blind Branded", "Sample Type"],
    BrandRecognitionHairCare: ["Brand recognition"],
    customOrderSub: [
        "Seq. Monadic",
        "Monadic",
        "Male",
        "Female",
        "Non-binary",
        "I use a different term",
        "16-25 Years Old",
        "26-35 Years Old",
        "36-45 Years Old",
        "46-55+ Years Old",
        "Bar from 0 to 100",
        "It prevents/controls against wetness",
        "It prevents/controls against odor",
        "It does not cause white marks on skin or clothes",
        "Kind to skin",
        "I like the fragrance",
        "I like the packaging",
        "I like the brand",
        "AP Only",
        "Deo Only",
        "AP & Deo",
        "Non-Dual User",
        "Dual User",
        "Antiperspirant Solid/Stick",
        "Antiperspirant Roll-On",
        "Antiperspirant Aerosol Spray / Dry Spray",
        "Antiperspirant Cream",
        "Antiperspirant Gel",
        "Deodorant Solid/Stick",
        "Deodorant Roll-On",
        "Deodorant Bodyspray/ Aerosol Spray",
        "Lotion",
        "Powder",
        "Perfume",
        "None of these",
        "Multiple times a day",
        "Every day",
        "5-6 times a week",
        "3-4 times a week",
        "1-2 times a week",
        "Less often than once a week",
        "Dry spray users",
        "Dry spray non-users + non-rejectors",
        "Light Sweater",
        "Medium Sweater",
        "Anxious Sweater",
        "Heavy Sweater",
        "Excessive Sweater",
        "Non-Active User",
        "Medium-Low Active User",
        "Active User",
        "Less than once a week",
        "1-2 times a week",
        "3-4 times a week",
        "5-6 times a week",
        "Everyday",
        "Multiple times a day",
        "3+ times per day",
        "2 times per day",
        "Once per day",
        "Less than once per day",
        "I could smell body odor and wanted to cover it up",
        "I could no longer smell the product’s fragrance",
        "I wanted to top up my fragrance",
        "I wanted to top up my protection",
        "I wanted to freshen up",
        "I was re-applying the product after having a shower / bath",
        "I was going out somewhere and wanted to make sure I smelt fresh",
        "Other reason",
        "Underarm/armpits",
        "Arms",
        "Back",
        "Chest",
        "Clothes",
        "Feet",
        "Groin",
        "Hair",
        "Hands",
        "Legs",
        "Neck",
        "Shoes",
        "Shoulders",
        "Stomach",
        "Wrist",
        "Other",
        "Morning",
        "Afternoon",
        "Evening",
        "Before bed",
        "At another point during the day",
        "same as Format of Antiperspirant & Deodorant",
        "Recognisers",
        "Non-Recogniser",
        "Shaved",
        "Waxed",
        "Plucked",
        "Epilated",
        "Used other method of underarm hair removal",
        "None of the above",
        "Burning",
        "Stinging",
        "Itching",
        "Tingling",
        "Redness",
        "Rashes or bumps",
        "Others",
        "Didn’t have any problems",
    ],
    alphabeticOrderFilters: ["Age Range", "Country Region", "Ethnicity", "Consumer's Current Brand", "Product Purchased From", "Sweat Moments", "Most Important Sweat Moment", "Brand correctly recognized"],
    correlationConsumerFilters: ["Gender", "Age Range", "Sweater Type", "Consumer's Current Brand"],
    correlationConsumerFiltersForOralCare: ["Sample Type", "Brand Usership", "City", "Age Range", "LSM bracket", "Exact Brand"],
    correlationConsumerFiltersForSkinCleansing: [
        "Blind Branded",
        "City",
        "Gender",
        "Exact LSM",
        "Age Range",
        "Brand Usership",
        "Usership (Loyalty)",
        "Frequency of Usage",
        "Number of times body wash used",
        "Often usage-freq of usage",
        "Personal Usage of product (times prod used)",
        "Product Usage",
        "Implement used",
        "Time of Bathing Time",
        "Sample Type",
        "Test Code",
        "Test Design",
        "Test ID",
    ],
    correlationConsumerFiltersForSkinCare: [
        "Gender",
        "Consumer Exact Age",
        "Age Range",
        "Race",
        "Exact LSM",
        "LSM bracket",
        "Region",
        "Skin tone",
        "Skin type",
        "Sensitivity face skin",
        "Often wear hijab"
    ],
    correlationConsumerFiltersForUFH: [
        "Age Range",
        "Gender",
        "City",
        "Consumer Exact Age",
        "Additional products used in wash",
        "Agree to info provided and book",
        "Allergy reaction in recent twelve months",
        "Applicable conditions",
        "Availablity consent",
        "Choice between product tested and most often used",
        "Company working details",
        "Current living situation be able to wear clothes after two days wash",
        "Cycle best describes just completed a wash on",
        "Describe decision to purchase laundry products",
        "Emotions felt after smelling frag",
        "Ethnicity",
        "Fabric conditioner used alongside",
        "Feel positive smelling product",
        "Feel smelling product",
        "Format of laundry detergent",
        "Frag feel unqiue different",
        "Frag fits Addictive",
        "Frag fits Chemical",
        "Frag fits Classic",
        "Frag fits Comforting / Relaxing",
        "Frag fits Energising",
        "Frag fits Exotic",
        "Frag fits Feminine",
        "Frag fits Fresh",
        "Frag fits Luxurious",
        "Frag fits Makes me feel good",
        "Frag fits Masculine",
        "Frag fits Natural / Outdoorsy",
        "Frag fits New and Different",
        "Frag fits Overpowering",
        "Frag fits Premium",
        "Frag fits Sophisticated",
        "Frag fits word onscreen",
        "Frag fits Worth paying more for",
        "Frag fits Youthful",
        "Frag in room with water used from laundry",
        "Frag of product assosciate with",
        "Frag strength fill room when clothes were drying",
        "Garment material",
        "Garment type",
        "Happy to replace current laundry detergent with different liquid detergent",
        "Like dislike doing laundry",
        "Likely would buy laundry detergent product if available",
        "Liquid laundry detergent brands currently use",
        "Liquid laundry detergent brands never use",
        "Market research study about",
        "Method used to dry clothes",
        "Miss most about the product tested",
        "Most fiting for frag",
        "Own a smartphone",
        "Product made feel unexpectedly lifted",
        "Products used alongside test product in washing",
        "Ranking",
        "Reuse water from laundry to clean",
        "Tempearture just completed wash on",
        "Types of products used at home",
        "Washes completed using test product in past seven days",
        "Weekly Avg of laundry done",
        "Working for company involved in marketing",
        "Would you be able to download app on phone"
    ],
};

export default ConsumerFilterOrder;
